import { render, staticRenderFns } from "./PolicyDocumentList.vue?vue&type=template&id=4c223a7a"
import script from "./PolicyDocumentList.vue?vue&type=script&lang=js"
export * from "./PolicyDocumentList.vue?vue&type=script&lang=js"
import style0 from "./PolicyDocumentList.vue?vue&type=style&index=0&id=4c223a7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports